import React from 'react';

import './style.less';

const Reviews = (props) => {
  return (
    <div id="bv-reviews">
      <div className="reviews-wrapper">
        {props.children}
      </div>
    </div>
  );
};

export default Reviews;
